import { type ReactNode, useCallback, useRef } from 'react';

import Menu from '../../ui/menus/menu/menu';
import type { MenuItem } from '../../ui/menus/menu/types';
import type { HDirection, VDirection } from '../../ui/popover/utils';
import PopoverTrigger, {
  type PopoverTriggerHandle,
} from '../../ui/popover_trigger/popover_trigger';

type Props = {
  triggerElement: ReactNode;
  menuItems: MenuItem[];
  onMenuItemClick: (menuItem: MenuItem) => void;
  showIcons?: boolean;
  hDirectionHint?: HDirection;
  vDirectionHint?: VDirection;
};

export function TriggerMenu({
  triggerElement,
  menuItems,
  onMenuItemClick,
  showIcons,
  hDirectionHint,
  vDirectionHint,
}: Props) {
  const popoverTriggerHandle = useRef<PopoverTriggerHandle>(null);

  const handleMenuItemClick = useCallback(
    (menuItem: MenuItem, event: React.MouseEvent) => {
      if (menuItem.autoClose !== false && !event.defaultPrevented) {
        popoverTriggerHandle.current?.close();
      }
      onMenuItemClick?.(menuItem);
    },
    [onMenuItemClick],
  );

  return (
    <PopoverTrigger
      triggerElement={triggerElement}
      hDirectionHint={hDirectionHint}
      vDirectionHint={vDirectionHint}
      ref={popoverTriggerHandle}
    >
      <Menu
        menuItems={menuItems}
        onMenuItemClick={handleMenuItemClick}
        showIcons={showIcons}
      />
    </PopoverTrigger>
  );
}
